import {
  HistoryOutlined,
  NotificationOutlined,
  TagsOutlined,
  EyeInvisibleOutlined,
  UserOutlined,
  AimOutlined,
  AppstoreAddOutlined,
  TagOutlined,
  FileImageOutlined,
  SkinOutlined,
  GiftOutlined,
  PlayCircleOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import React from 'react';
import {
  IconGraphics,
  IconServer,
  IconTexts,
  IconMainstays,
  IconMarquee,
  IconJustin,
  IconJustinHome,
  IconPlayer,
  IconGameProfile,
} from '../../assets';
import { IconCategories } from '../../assets/svg/IconCategories';
import { PAGES } from '../urls/page-urls';

export const SIDER_MENU: SiderMenuInterface[] = [
  {
    id: '1',
    name: 'HOME',
    group: [
      {
        id: '10',
        name: 'The Daily',
        route: PAGES.HOME.FOLDER.THE_DAILY,
        icon: <IconJustinHome />,
      },
      {
        id: '13',
        name: 'Product',
        route: PAGES.HOME.PRODUCT,
        icon: <SkinOutlined />,
      },
      {
        id: '11',
        name: 'Cartner Convos',
        route: PAGES.HOME.CARTNER_CONVOS,
        icon: <QuestionCircleOutlined />,
      },
    ],
  },
  {
    id: '2',
    name: 'PLAY',
    group: [
      {
        id: '21',
        name: 'Background Image',
        route: PAGES.PLAY_BG_IMAGE,
        icon: <FileImageOutlined />,
      },
    ],
  },
  {
    id: '3',
    name: 'SHOP',
    group: [
      {
        id: '31',
        name: 'Marquee',
        route: PAGES.PRODUCT_TILE,
        icon: <IconMarquee />,
      },
      {
        id: '32',
        name: 'Promotion',
        route: PAGES.PROMOTION,
        icon: <NotificationOutlined />,
      },
      {
        id: '33',
        name: 'Product Carousel',
        route: PAGES.MORE_FOR_YOU,
        icon: <AppstoreAddOutlined />,
      },
      {
        id: '36',
        name: 'Categories',
        route: PAGES.CATEGORIES,
        icon: <IconCategories />,
      },
      {
        id: '34',
        name: 'Mainstays',
        route: PAGES.MAINSTAYS,
        icon: <IconMainstays />,
      },
      {
        id: '35',
        name: 'Product Catalog',
        route: PAGES.PRODUCT_CATALOG,
        icon: <TagOutlined />,
      },
    ],
  },
  {
    id: '4',
    name: 'CLUBHOUSE',
    group: [
      {
        id: '40',
        name: 'Just In - Clubhouse',
        route: PAGES.CLUB_HOUSE.JUST_IN,
        icon: <IconJustin />,
      },
      {
        id: '41',
        name: 'Tour Stories',
        route: PAGES.CLUB_HOUSE.TOUR_STORY,
        icon: <PlayCircleOutlined />,
        style: { marginLeft: 20 },
      },
      {
        id: '42',
        name: 'Players & Coaches',
        route: PAGES.CLUB_HOUSE.PLAYER,
        icon: <IconPlayer />,
      },
    ],
  },
  {
    id: '5',
    name: 'LOYALTY',
    group: [
      {
        id: '50',
        name: 'Perks',
        route: PAGES.PERKS,
        icon: <TagsOutlined />,
      },
      {
        id: '51',
        name: 'Loyalty Actions',
        route: PAGES.LOYALTY_ACTION,
        icon: <AimOutlined />,
      },
      {
        id: '53',
        name: 'Tour Trash',
        route: PAGES.TOUR_TRASH,
        icon: <GiftOutlined />,
      },
      {
        id: '54',
        name: 'My Game Profile',
        route: PAGES.MY_GAME_PROFILE,
        icon: <IconGameProfile />,
      },
    ],
  },
  {
    id: '6',
    name: 'ADMIN',
    group: [
      {
        id: '60',
        name: 'User Profile',
        route: PAGES.USER_PROFILE,
        icon: <UserOutlined />,
      },
      {
        id: '61',
        name: 'Show/Hide Features',
        route: PAGES.SHOW_HIDE_FEATURES,
        icon: <EyeInvisibleOutlined />,
      },
      {
        id: '62',
        name: 'Activity Log',
        route: PAGES.ACTIVITY_LOG,
        icon: <HistoryOutlined />,
      },
      {
        id: '63',
        name: 'Server Health',
        route: PAGES.SERVER_HEALTH,
        icon: <IconServer />,
      },
    ],
  },
  {
    id: '7',
    name: 'APPLICATION ASSETS',
    group: [
      {
        id: '70',
        name: 'Graphics',
        route: PAGES.GRAPHICS.OTHER,
        icon: <IconGraphics />,
      },
      {
        id: '71',
        name: 'Text',
        route: PAGES.TEXT,
        icon: <IconTexts />,
      },
    ],
  },
];

export interface SiderMenuChildren {
  id: string;
  name: string;
  route?: string;
  icon?: React.ReactNode;
  roles?: number[];
  style?: any;
}

export interface SiderMenuChildrenGroup extends SiderMenuChildren {
  children?: SiderMenuChildren[];
  roles?: number[];
}

export interface SiderMenuInterface extends SiderMenuChildren {
  group?: SiderMenuChildrenGroup[];
  roles?: number[];
}
